const VOICES = [
  { q: "FIT WAS UNREAL. SHIPS FAST. WORE IT TO PRACTICE AND COACH BENCHED ME.", n: "@KAI / DALLAS" },
  { q: "MY MOM SAID IT LOOKS TOO AGGRESSIVE. SHE'S RIGHT. I LOVE IT.", n: "@RYE / LONDON" },
  { q: "FINALLY A BRAND THAT GETS IT. NOT FAST FASHION. NOT BORING. JUST HEAT.", n: "@MILO / TOKYO" },
  { q: "DROP 001 SOLD OUT IN 4 MIN. I CAMPED 3HRS AT MY LAPTOP. NO REGRETS.", n: "@ANAÏS / PARIS" },
];

export default function Voices() {
  return (
    <section data-testid="voices" className="border-b border-white/20 bg-ink">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="flex items-end justify-between flex-wrap gap-3 mb-10">
          <div>
            <p className="text-blood text-xs tracking-[0.3em] font-mono mb-2">// VOICES FROM THE STREET</p>
            <h2 className="font-anton uppercase text-bone text-4xl sm:text-6xl tracking-tighter">
              WHAT THE <span className="text-blood">REBELS</span> SAY
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {VOICES.map((v, i) => (
            <blockquote
              key={i}
              className="border border-white/15 p-5 bg-surface relative hover:border-blood transition-colors"
            >
              <span className="absolute -top-3 left-4 bg-ink px-2 font-marker text-blood text-2xl leading-none">"</span>
              <p className="text-bone text-sm leading-relaxed font-mono pt-2">{v.q}</p>
              <footer className="mt-4 pt-3 border-t border-white/10 text-[11px] tracking-[0.2em] uppercase text-ash">
                — {v.n}
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
